import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import ReactPlayer from "react-player/vimeo";

const StyledWrapper = styled.div`
  position: relative;
  height: 85vh;
  width: 100vw;
  background-color: ${(props) => props.theme.color[props.backgroundColor]};
  color: ${(props) => props.theme.color[props.textColor]};
  overflow: hidden;
`;

const StyledContent = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
`;

const StyledReactPlayer = styled(ReactPlayer)`
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 1;
  pointer-events: none;
`;

const StyledBackground = styled.div`
  display: ${(props) => (props.size === "mobile" ? "block" : "none")};
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 0;
  ${(props) => props.theme.responsive.mobile} {
    display: ${(props) => (props.size === "desktop" ? "block" : "none")};
  }
`;

export default function BaseHeader({
  textColor,
  backgroundColor,
  backgroundAsset,
  vimeoURL,
  children,
}) {
  const [hasRan, setHasRan] = useState(false);
  const [screenSize, setScreenSize] = useState({
    height: 0,
    width: 0,
  });
  const updateScreenSize = () => {
    setScreenSize({ width: window.innerWidth, height: window.innerHeight });
  };
  useEffect(() => {
    if (!hasRan) {
      setHasRan(true);
      updateScreenSize();
    }
    window.addEventListener("resize", updateScreenSize);
    return () => {
      window.removeEventListener("resize", updateScreenSize);
    };
  }, [screenSize]);
  return (
    <StyledWrapper textColor={textColor} backgroundColor={backgroundColor}>
      <StyledContent>{children}</StyledContent>
      {vimeoURL && (
        <StyledReactPlayer
          width={
            screenSize.width / screenSize.height > 16 / 9 ? "100vw" : "177.78vh"
          }
          height={
            screenSize.width / screenSize.height < 16 / 9 ? "100vh" : "56.25vw"
          }
          light={false}
          controls={false}
          url={vimeoURL}
          playing={true}
          loop={true}
          muted={true}
          playsinline={true}
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            objectFit: "fill",
            transform: "translate(-50%, -50%)",
          }}
        />
      )}
      {backgroundAsset && backgroundAsset.mobile && (
        <StyledBackground size="mobile">
          <GatsbyImage
            style={{
              width: "100%",
              height: "100%",
            }}
            imgStyle={{
              objectFit: "cover",
              objectPosition: "center center",
            }}
            alt="Hero"
            image={getImage(backgroundAsset.mobile.imageFile)}
          />
        </StyledBackground>
      )}
      {backgroundAsset && backgroundAsset.desktop && (
        <StyledBackground size="desktop">
          <GatsbyImage
            style={{
              width: "100%",
              height: "100%",
            }}
            imgStyle={{
              objectFit: "cover",
              objectPosition: "center center",
            }}
            alt="Hero"
            image={getImage(backgroundAsset.desktop.imageFile)}
          />
        </StyledBackground>
      )}
    </StyledWrapper>
  );
}
